(function ($) {

  // PC - スクロール後メニュー
  var $win = $(window),
      $cloneNav = $('.clone-header').clone().addClass('clone-nav').appendTo('#page'),
      showClass = 'is-show';

  $win.on('load scroll', function() {
    var value = $(this).scrollTop();
    if ( value > 600 ) {
      $cloneNav.addClass(showClass);
    } else {
      $cloneNav.removeClass(showClass);
    }
  });

  // PC - ドロップメニュー
  if (window.matchMedia('(min-width: 1021px)').matches) {
    $('.primary-menu').children('.menu-item').hover(function(){
      $(this).addClass('active');
      $("ul:not(:animated)",this).fadeIn(280);
    }, function(){
      $(this).removeClass('active');
      $("ul.sub-menu",this).hide();
    });
  }

  // SP - トグルメニュー
  $('.sp-menu').on("click", function(){

      $('#sp-gNav').fadeToggle(300, "swing");

  });

  // 閉じるボタン
  $('.btn-sp-close').click(function() {
    $('#sp-gNav').fadeOut(300);
  })

  // SP - サブメニュー開閉
  $('.primary-menu-sp .menu-item').on("click", function(){
    $(this).find('.sub-menu').slideToggle('first');

  });


})(jQuery);